// SidebarItem.tsx
import { Icon } from "@iconify/react";
import { Link } from "react-router";
import { type SidebarItem } from "./interfaces/sidebarItems";

interface Props {
  item: SidebarItem;
}

export function SidebarItem({ item }: Props) {
  return (
    <Link
      to={item.href}
      target={item.external ? "_blank" : "_self"}
      rel={item.external ? "noopener noreferrer" : undefined}
      className="flex items-center gap-3 rounded-lg px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-800 transition"
    >
      <Icon icon={item.icon} className="h-6 w-6 dark:text-primary text-tealGreen" />
      <span className="text-sm font-medium dark:text-white text-gray-800">
        {item.label}
      </span>
    </Link>
  );
}
